export default defineNuxtPlugin(() => {
  const { categories, resolved } = useCookieConsent()
  const stored = window.getCkyConsent?.()

  categories.value = categoriesFromCkyConsent(stored)
  resolved.value = stored !== undefined

  document.addEventListener('cookieyes_banner_load', event => {
    categories.value = categoriesFromCkyConsent(event.detail)
    resolved.value = true
  })

  document.addEventListener('cookieyes_consent_update', event => {
    categories.value = categoriesFromConsentUpdate(event.detail)
    resolved.value = true
  })
})

